var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobSites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.998 511.998",
    style: {
      enableBackground: "new 0 0 511.998 511.998"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M74.664,85.179c-17.673,0-32,14.327-32,32v85.333h21.333v-85.333c0-5.891,4.776-10.667,10.667-10.667h256V85.179H74.664z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M74.664,405.179c-5.891,0-10.667-4.776-10.667-10.667V287.845H42.664v106.667c0,17.673,14.327,32,32,32h106.667v-21.333 H74.664z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M338.206,432.688L79.155,173.637c-4.165-4.164-10.917-4.164-15.083,0L3.123,234.587c-4.164,4.165-4.164,10.917,0,15.083 L262.174,508.72c2,2.001,4.713,3.125,7.541,3.125c2.829-0.001,5.541-1.125,7.541-3.125l60.949-60.949 C342.37,443.605,342.37,436.853,338.206,432.688z M269.715,486.096L25.747,242.128l45.867-45.867L315.582,440.23L269.715,486.096z "
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M469.331,405.179h-160v21.333h117.333v53.333c0,5.891,4.776,10.667,10.667,10.667h32 c23.564,0,42.667-19.102,42.667-42.667C511.998,424.281,492.895,405.179,469.331,405.179z M469.331,469.179h-21.333v-42.667 h21.333c11.782,0,21.333,9.551,21.333,21.333C490.664,459.628,481.113,469.179,469.331,469.179z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M469.331,85.179h-53.333v21.333h53.333c11.782,0,21.333,9.551,21.333,21.333v320h21.333v-320 C511.998,104.281,492.895,85.179,469.331,85.179z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 164.042,
    y: 314.513,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -175.2621 227.2397)",
    width: 45.259,
    height: 21.333
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 121.376,
    y: 271.846,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -157.5885 184.5736)",
    width: 45.259,
    height: 21.333
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 206.686,
    y: 357.18,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -192.9419 269.8904)",
    width: 45.259,
    height: 21.333
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 249.372,
    y: 399.868,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -210.6241 312.5771)",
    width: 45.259,
    height: 21.333
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 78.679,
    y: 229.18,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -139.9243 141.885)",
    width: 45.259,
    height: 21.333
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M460.094,23.824L445.352,9.083c-12.473-11.907-32.103-11.907-44.576,0L238.579,171.28c-4.164,4.165-4.164,10.917,0,15.083 l44.235,44.235c1.995,2.008,4.711,3.133,7.541,3.125c2.829-0.001,5.541-1.125,7.541-3.125L460.094,68.4 c0.005-0.005,0.01-0.01,0.015-0.015C472.41,56.076,472.403,36.125,460.094,23.824z M445.022,53.307L290.355,207.973 l-29.152-29.152L415.87,24.165c4.028-3.849,10.372-3.849,14.4,0l14.752,14.731c0.001,0.002,0.003,0.003,0.005,0.005 C449.003,42.88,449.001,49.33,445.022,53.307z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M286.931,212.944l-46.037,15.371l15.371-46.112l-20.267-6.752l-22.123,66.357c-0.362,1.088-0.547,2.227-0.547,3.373 c0.001,5.891,4.778,10.666,10.669,10.664c1.129,0.004,2.252-0.169,3.328-0.512l66.357-22.123L286.931,212.944z"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 390.275,
    y: 36.943,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 69.1923 303.4905)",
    width: 21.333,
    height: 62.56
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 223.998,
    y: 234.512,
    width: 160,
    height: 21.333
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 405.331,
    y: 234.512,
    width: 21.333,
    height: 21.333
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 447.998,
    y: 234.512,
    width: 21.333,
    height: 21.333
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null)), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null)), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null)), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null)), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null)), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null)), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null)), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null)), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null)), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null)), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null)), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null)), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null)), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null)), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobSites);
export default __webpack_public_path__ + "static/media/job_sites.548f773feb00d904c1617a558a1bce9d.svg";
export { ForwardRef as ReactComponent };